const developConfig = {
  ACCESS_KEY: "AIzaSyBHOsy7ieXVurgLMbbq3UTaJWK45BlU25o"
}

module.exports = developConfig;



//////////////////
// WEBPACK FOOTER
// ./config/.development.js
// module id = pP7R
// module chunks = 1